import { NumberValidering } from '../../Shared/Scripts/Utilities/Validering';
import VeilederVgsUrDto from '../Models/VeilederVgsUrDto';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';

export const fSkolepengerValidering = (maxVerdi: number, locale: string): NumberValidering<VeilederVgsUrDto> => {
    return {
        min: 0,
        max: maxVerdi,
        minFeil: 'obsMeldingMinSkolepengerBelop',
        maxFeil: 'obsMeldingMaxSkolepengerBelop',
        variablesMap: new Map<string, string>([
            ['${min}', '0'],
            ['${max}', tilPengerFormat(maxVerdi, locale)],
        ]),
    };
};

export const dArstimerValidering = (maxVerdi: number): NumberValidering<VeilederVgsUrDto> => {
    return {
        min: 1,
        max: maxVerdi,
        minFeil: 'obsMeldingMinArstimer',
        maxFeil: 'obsMeldingMaxArstimer',
        variablesMap: new Map<string, string>([
            ['${min}', '1'],
            ['${max}', maxVerdi.toString()],
        ]),
    };
};

export const dProsentValidering: NumberValidering<VeilederVgsUrDto> = {
    min: 1,
    max: 100,
    minFeil: 'obsMeldingMinProsent',
    maxFeil: 'obsMeldingMaxProsent',
    variablesMap: new Map<string, string>([
        ['${min}', '1'],
        ['${max}', '100'],
    ]),
};
